import { render, staticRenderFns } from "./detail_background.vue?vue&type=template&id=4c25f482&scoped=true&"
import script from "./detail_background.vue?vue&type=script&lang=js&"
export * from "./detail_background.vue?vue&type=script&lang=js&"
import style0 from "./detail_background.vue?vue&type=style&index=0&id=4c25f482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25f482",
  null
  
)

export default component.exports